import { render } from "./select-banked-user-modal.vue?vue&type=template&id=24e7997a"
import script from "./select-banked-user-modal.vue?vue&type=script&lang=js"
export * from "./select-banked-user-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__